import { IResponse } from 'src/interface';
import { getWithPath } from 'src/utils/http';

const API_PATH = {
    GET_CONFIG: '/app/get/config',
    GET_FOOTER: '/app/get/footer',
    GET_REGION: '/slave/external/get/region',
    GET_SLIDE_FOOTER: '/slave/external/get/banner',
    GET_JUMP_LINK: '/slave/external/get/jump-link',
    GET_CHECK_APP: '/slave/external/get/check-app',
    GET_ZSHORT_VIDEO: '/event/get/zshort'
};

export interface IAppMenu {
    name: string;
    url: string;
    pageType?: string;
}

export interface IAppTag {
    name: string;
    url: string;
}

export interface ICategory {
    id: number;
    name: string;
    url: string;
    childs: ICategory[];
    newTab?: boolean;
}

export interface IAppConfig {
    menus: IAppMenu[];
    tags: IAppTag[];
    categories: ICategory[];
}

export interface IAppRegion {
    tts: number[];
    province?: string;
    countryCode: string;
    region: {
        id: number;
        name: string;
        shortName: string;
        link: string;
    };
}

export const AppService = {
    getConfig: (): Promise<IResponse<IAppConfig>> => {
        return getWithPath(API_PATH.GET_CONFIG);
    },
    getFooter: (id: string): Promise<IResponse<IAppConfig>> => {
        return getWithPath(API_PATH.GET_FOOTER, { id });
    },
    getRegion: (): Promise<IResponse<IAppRegion>> => {
        return getWithPath(API_PATH.GET_REGION);
    },
    getSlideFooter: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_SLIDE_FOOTER);
    },
    getJumpLink: (url: string): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_JUMP_LINK, { targetUrl: url });
    },
    checkApp: ({ installedZalo = false, installedBM = false, activeZalo = false }): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_CHECK_APP, { installedZalo, installedBM, activeZalo });
    },
    getZShorts: (size: number, categoryId: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_ZSHORT_VIDEO, { size, categoryId });
    },
};

export default AppService;
